<template>
    <div class="mtg-agents-facts">
        <div class="mtg-agents-facts__tr mtg-agents-facts__th">
            <p class="g-text__p _gray g_semibold">Дата</p>
            <p class="g-text__p _gray g_semibold g-d-m-none">Сообщение</p>
        </div>
        <template
            v-for="fact in data.data"
            :key="`doc-${fact.id}`"
        >
            <div
                v-if="fact.detail_url"
                class="mtg-agents-facts__tr"
            >
                <p class="mtg-agents-facts__td g-text__p g_semibold">{{ fact.active_from }}</p>
                <p v-html="fact.name" class="mtg-agents-facts__td g-text__p" />
                <a :href="fact.detail_url" class="mtg-agents-facts__link"></a>
            </div>
            <div
                v-else
                class="mtg-agents-facts__tr"
            >
                <p class="mtg-agents-facts__td g-text__p g_semibold">{{ fact.active_from }}</p>
                <p v-html="fact.name" class="mtg-agents-facts__td g-text__p" />
                <a
                    v-if="fact.props && fact.props.file"
                    :href="fact.props.file.src"
                    class="mtg-agents-facts__link"
                ></a>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'MortAgentsFacts',
    props: {
        data: {
            type: Object,
            default () {
                return [];
            }
        }
    },
};
</script>
